import { supabase } from '../supabase';

export const followersService = {
  // Seguir a un usuario
  async followUser(followingId) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No autenticado');

    const { data, error } = await supabase
      .from('followers')
      .insert({
        follower_id: user.id,
        following_id: followingId
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Dejar de seguir
  async unfollowUser(followingId) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No autenticado');

    const { error } = await supabase
      .from('followers')
      .delete()
      .eq('follower_id', user.id)
      .eq('following_id', followingId);

    if (error) throw error;
    return true;
  },

  // Verificar si sigo a un usuario
  async isFollowing(followingId) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return false;

    const { data, error } = await supabase
      .from('followers')
      .select('id')
      .eq('follower_id', user.id)
      .eq('following_id', followingId)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return !!data;
  },

  // Obtener usuarios que sigo
  async getFollowing() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No autenticado');

    const { data, error } = await supabase
      .from('followers')
      .select(`
        id,
        following_id,
        created_at,
        profiles:following_id (
          id,
          email,
          username,
          avatar_url
        )
      `)
      .eq('follower_id', user.id)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  // Obtener mis seguidores
  async getFollowers() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No autenticado');

    const { data, error } = await supabase
      .from('followers')
      .select(`
        id,
        follower_id,
        created_at,
        profiles:follower_id (
          id,
          email,
          username,
          avatar_url
        )
      `)
      .eq('following_id', user.id)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  // Obtener todos los usuarios disponibles para seguir
  async getSuggestedUsers() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No autenticado');

    // Obtener todos los usuarios excepto yo mismo
    const { data: allUsers, error: usersError } = await supabase
      .from('profiles')
      .select('id, email, username, avatar_url')
      .neq('id', user.id)
      .limit(50);

    if (usersError) throw usersError;

    // Obtener usuarios que ya sigo
    const { data: following, error: followingError } = await supabase
      .from('followers')
      .select('following_id')
      .eq('follower_id', user.id);

    if (followingError) throw followingError;

    const followingIds = (following || []).map(f => f.following_id);

    // Marcar quiénes ya sigo
    const usersWithFollowStatus = (allUsers || []).map(u => ({
      ...u,
      isFollowing: followingIds.includes(u.id)
    }));

    return usersWithFollowStatus;
  }
};
